<template>
    <b-container>
        <b-row v-if="isIntuitApp" class="d4d-decoration">
        </b-row>
        <b-row v-if="isJAApp" class="ja-decoration">
        </b-row>
        <b-form @submit.prevent="changePassword()">
            <b-row class="d4d-login">
               
                <b-col cols="12" class="mt-1 title">Change Password</b-col>
                <b-col cols="12 mt-4">
                    <label for="password">Current Password</label>
                    <input id="password" type="password" v-model="form.currentPassword" value="">
                    <span v-if="currentPasswordError" class="form-error">This field is required</span>
                    <ul class="mt-2 error-content">
                        <li class="error-text" v-for="error in currentPasswordErrors">{{ error }}</li>
                    </ul>
                </b-col>                
                <b-col cols="12 mt-4">
                    <label for="new-password">New Password</label>
                    <input id="new-password" type="password" v-model="form.password" value="">
                    <span v-if="passwordError" class="form-error">This field is required</span>
                    <ul class="mt-2 error-content">
                        <li class="error-text" v-for="error in passwordErrors">{{ error }}</li>
                    </ul>
                </b-col>
                <b-col cols="12 mt-4">
                    <label for="confirm-password">Confirm Password</label>
                    <input id="confirm-password" type="password" v-model="form.confirmPassword" value="">
                    <span v-if="confirmPasswordError" class="form-error">{{ confirmPasswordError }}</span>
                </b-col>
                <b-col cols="12" class="mt-5">
                    <b-button block variant="primary" type="submit">Change Password</b-button>
                </b-col>
                <b-col cols="12" class="mt-3 mb-4">
                    <b-button block variant="light" @click="cancel()">Cancel</b-button>
                </b-col>
            </b-row>
        </b-form>
        <legal-message/>
    </b-container>
</template>

<script>
    import { UserService } from '../Services';
    import { Spinner, Storage } from '../../../core/Utils'
    import LegalMessage from "../Components/LegalMessage"

    export default {
        name: 'ChangePassword',
        components: { LegalMessage },
        data(){
            return {
                form: { currentPassword: "", password: "", confirmPassword: "" },
                currentPasswordError: false,
                passwordError: false,
                confirmPasswordError: "",
                currentPasswordErrors: [],
                passwordErrors: [],
                serviceError: false
            }
        },
        methods: {
            changePassword(){
                const form = this.form;

                const currentPassword = form.currentPassword;
                const password = form.password;
                const confirmPassword = form.confirmPassword;
                this.currentPasswordError = currentPassword === "";
                this.passwordError = password === "";
                this.confirmPasswordError = ""

                if(confirmPassword === "") this.confirmPasswordError = "This field is required";
                if(password !== confirmPassword) this.confirmPasswordError =  "Must coincide with password";
                if(confirmPassword !== "" && password === confirmPassword) this.confirmPasswordError =  "";

                if(currentPassword && password && confirmPassword && password === confirmPassword) {
                    Spinner.start()
                    this.passwordErrors = []
                    this.currentPasswordErrors = []
                    this.serviceError = false

                    UserService.changeUserPassword(form).then(response => {
                        Spinner.stop()
                        this.$router.go(-1)
                    }).catch(err => {
                        Spinner.stop()
                        this.serviceError = 'Unexpected error, please try again.'
                        if (err) {
                            if (err.message) {
                                this.serviceError = err.message
                            }
                            if (err.errors && err.errors['Password']) {
                                err.errors['Password'].forEach(error => this.passwordErrors.push(error))
                            }
                            if (err.errors && err.errors['CurrentPassword']) {
                                err.errors['CurrentPassword'].forEach(error => this.currentPasswordErrors.push(error))
                            }
                        }
                    })
                }
            },
            cancel(){
                this.$router.go(-1)
            }
        },
        created() {
            const user = Storage.getUser()
        }
    }

</script>
<style scoped lang="stylus">

    @import "../Styles/security_styles.styl"

    .last-updated
        font-family arial, sans-serif
        font-size 12px
        font-weight bold
        font-style italic
        color black

</style>